import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

type ProgressProps = {
  className?: string
  progress: number
  step: string
  name: string
}

function ProgressComponent({ progress, step, className, name }: ProgressProps) {
  return (
    <div className={className}>
      <ProgressBar $progress={progress} />
      <plume.styles.heading.XXXXXS>
        <Step>{step}</Step>
        <Name>{name}</Name>
      </plume.styles.heading.XXXXXS>
    </div>
  )
}

export const Progress = styled(ProgressComponent)`
  ${plume.styles.heading.XXXXXS} {
    margin: 8px 16px;
  }
`

const Name = styled.span`
  color: ${plume.COLORS.PRIMARY_BLACK};
  margin-left: 8px;
`

const Step = styled.span`
  color: ${plume.COLORS.GREY_SHADE_2};
`

const ProgressBar = styled.div<{ $progress: number }>`
  background: ${plume.COLORS.PRIMARY_SAND};
  height: 15px;
  width: 100%;
  border-radius: 16px;

  &:before {
    content: '';
    background: ${plume.COLORS.PRIMARY_GREEN};
    height: 15px;
    position: absolute;
    left: 0;
    top: 0;
    right: ${({ $progress }) => Math.floor((1 - $progress) * 100)}%;
    border-radius: 16px;
  }
`
